module.exports = __webpack_public_path__ + "static/epstein-c5bd159abe1b242a7b18ce0d91fcbcf1.jpeg";